import AvatarInfo from './AvatarInfo';

export default AvatarInfo;
